import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Zap } from 'lucide-react';
import { theme } from '../../utils/theme';

export const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer 
      className="border-t py-12 bg-black relative z-10" 
      style={{ borderColor: theme.colors.border }}
    >
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-2 opacity-50 hover:opacity-100 transition-opacity">
          <Zap size={20} color={theme.colors.textMuted} />
          <span className="font-bold text-lg text-gray-500">SAILECtech</span>
        </div>
        
        <div className="flex gap-8 text-sm text-gray-500">
          <a href="#filtres" className="hover:text-white transition-colors">{t.footer.filters}</a>
          <a href="#technologie" className="hover:text-white transition-colors">{t.footer.technology}</a>
          <a href="#support" className="hover:text-white transition-colors">{t.footer.support}</a>
          <a href="#pro" className="hover:text-white transition-colors">{t.footer.pro}</a>
        </div>
        
        <p className="text-sm text-gray-600">{t.footer.copyright}</p>
      </div>
    </footer>
  );
};
